import React, { useState, useEffect } from 'react';
import { TestResultCardCollection } from '../ui-components';
import { withAuthenticator } from '@aws-amplify/ui-react';
import { generateClient } from "aws-amplify/api";
import * as queries from '../graphql/queries';

const client = generateClient();

const TestExecutionsPage = ({ onStartQuiz2 }) => {
    const [testNames, setTestNames] = useState({});

    const startQuiz = async (testExecution) => {
        try {
            const test2 = await client.graphql({
                query: queries.getTest,
                variables: { id: testExecution.testID }
            });

            const test = test2.data.getTest;
            console.log("test Execution on TestExecutionPage" + JSON.stringify(testExecution));
            console.log("test on TestExecutionPage" + JSON.stringify(test));
            onStartQuiz2(test, testExecution);
        } catch (error) {
            console.error('Error fetching test', error);
        }
    };

    useEffect(() => {
        const fetchTestNames = async () => {
            try {
                const testExecutions = await client.graphql({
                    query: queries.listTestExecutions
                });

                const testIds = testExecutions.data.listTestExecutions.items.map(te => te.testID);
                const uniqueTestIds = [...new Set(testIds)];

                const testPromises = uniqueTestIds.map(id =>
                    client.graphql({
                        query: queries.getTest,
                        variables: { id }
                    })
                );

                const testResults = await Promise.all(testPromises);
                const testNamesMap = {};

                testResults.forEach(result => {
                    const test = result.data.getTest;
                    testNamesMap[test.id] = test.name;
                });

                setTestNames(testNamesMap);
            } catch (error) {
                console.error('Error fetching test names', error);
            }
        };

        fetchTestNames();
    }, []);

    return (
        <TestResultCardCollection
            overrideItems={({ item, index }) => ({
                backgroundColor: index % 2 === 0 ? 'white' : 'lightgray',
                onClick: () => startQuiz(item),
                overrides: {
                    "Test Name": {
                        children: testNames[item.testID] || 'Loading...',
                        onClick: () => startQuiz(item),
                    }
                }
            })}
        />
    );
};

export default withAuthenticator(TestExecutionsPage, {
    includeGreetings: true,
    formFields: {
        signUp: {
            email: { isRequired: true },
            family_name: { isRequired: true },
            given_name: { isRequired: true },
        }
    }
});